import { render, staticRenderFns } from "./NoRolesPermissionDeniedOverlay.vue?vue&type=template&id=c80e89da&scoped=true"
import script from "./NoRolesPermissionDeniedOverlay.vue?vue&type=script&lang=js"
export * from "./NoRolesPermissionDeniedOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e89da",
  null
  
)

export default component.exports